import React, { useEffect, useState } from 'react'
import { Stack, Grid, Typography, Chip } from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

import { getRecentEventsFrom } from '../../../model'
import { SiteViewModel } from '../../ViewModel'
import { useAppNavigate } from '../../../Paths'

interface DetailProps {
  label: string
  text: string
}

interface RecentEventCardProps {
  date: string
  time: string
  onClick: React.MouseEventHandler
}

interface SiteInfoPanelProps {
  site: SiteViewModel
}

function Detail({ label, text }: DetailProps) {
  const isValid = () => {
    return label && label !== '' && text && text !== ''
  }

  return (
    isValid() && (
      <Typography fontWeight="bold">
        {label}:<Typography component={'span'}> {text}</Typography>
      </Typography>
    )
  )
}

function RecentEventCard({ date, time, onClick }: RecentEventCardProps) {
  return (
    <Chip
      icon={<CalendarMonthIcon />}
      label={`${date} ${time}`}
      onClick={onClick}
    />
  )
}

function SiteInfoPanel({ site }: SiteInfoPanelProps) {
  const appNavigate = useAppNavigate()

  const [recentEvents, setRecentEvents] = useState([])

  useEffect(() => {
    let unsubscribed = false
    if (unsubscribed) return

    initializeRecentEvents()

    return () => {
      unsubscribed = true

      setRecentEvents([])
    }
  }, [site.id])

  const initializeRecentEvents = async () => {
    const recentEventsData = await getRecentEventsFrom(site.id, 5, 5)
    setRecentEvents(recentEventsData)
  }

  return (
    <Stack spacing={5}>
      <Grid container>
        <Grid item md={6}>
          <Detail label="Region" text={site.region} />
          <Detail label="Water way" text={site.waterway} />
          <Detail label="Zone" text={site.zone} />
          <Detail label="Catchment" text={site.catchment} />
        </Grid>
        <Grid item md={6}>
          <Detail label="Best Gauge Owner" text={site.bestGaugeOwner} />
          <Detail label="Gauge Station" text={site.gaugeStation ?? 'N/A'} />
          <Detail
            label="Location"
            text={`${site.latitude} : ${site.longitude}`}
          />
          <Detail label="Notes" text={site.notes} />
        </Grid>
      </Grid>

      <Stack spacing={1}>
        <Typography fontWeight="bold">Recent Events</Typography>
        <Grid container rowGap={1} columnGap={1}>
          {recentEvents.map((event, index) => {
            return (
              <RecentEventCard
                key={index}
                date={event.creationDate}
                time={event.timeOfRecord}
                onClick={() => {
                  appNavigate.toEvent(site.id, event.id)
                }}
              />
            )
          })}
        </Grid>
      </Stack>
    </Stack>
  )
}

export default SiteInfoPanel
